module.exports = __webpack_public_path__ + "img/qrcode_3.56422ce.jpg";